import { BALANCE } from '../balance';
import type { SetDefInput } from '../schemas/items';

/**
 * Décor sets (docs/design/content-items.md "Decor sets"). The +15 Coziness set bonus lives in CozinessConfig;
 * completionRewards are the one-time BALANCE.starsPer.setComplete stars from economy-progression §4 "Bộ sưu tập".
 */
export const SETS = [
  {
    id: 'set_tea',
    nameKey: 'set.set_tea.name',
    itemIds: [
      'fur_tea_table',
      'fur_tea_chair',
      'fur_tea_screen',
      'fur_tea_cabinet',
      'dec_tea_set',
      'dec_tea_lantern',
      'dec_tea_vase',
      'dec_tea_window',
      'dec_tea_rug',
      'dec_tea_scroll',
    ],
    completionRewards: [{ type: 'stars', amount: BALANCE.starsPer.setComplete }],
    iconFrame: 'item_dec_tea_set',
  },
  {
    id: 'set_old_europe',
    nameKey: 'set.set_old_europe.name',
    itemIds: [
      'fur_europe_table',
      'fur_europe_chair',
      'fur_europe_cupboard',
      'fur_europe_fireplace',
      'fur_europe_keepsake_chair',
      'dec_europe_candles',
      'dec_europe_books',
      'dec_europe_vase',
      'dec_europe_rug',
      'dec_europe_painting',
    ],
    completionRewards: [{ type: 'stars', amount: BALANCE.starsPer.setComplete }],
    iconFrame: 'item_dec_europe_candles',
  },
  {
    id: 'set_pine',
    nameKey: 'set.set_pine.name',
    itemIds: ['fur_bed_pine', 'fur_nightstand_pine', 'fur_wardrobe_pine', 'fur_desk_pine', 'fur_chair_pine'],
    completionRewards: [{ type: 'stars', amount: BALANCE.starsPer.setComplete }],
    iconFrame: 'ui_icon_set_pine',
  },
  {
    id: 'set_strawberry',
    nameKey: 'set.set_strawberry.name',
    itemIds: [
      'dec_strawberry_rug',
      'dec_heart_cushion',
      'dec_strawberry_clock',
      'fur_sofa_pink',
      'fur_beanbag_pink',
    ],
    completionRewards: [{ type: 'stars', amount: BALANCE.starsPer.setComplete }],
    iconFrame: 'ui_icon_set_strawberry',
  },
  {
    id: 'set_office',
    nameKey: 'set.set_office.name',
    // dec_mug_deadline only comes from Bao's Lv2 gift, so this set completes late on purpose.
    itemIds: [
      'dec_desk_lamp',
      'dec_cork_board',
      'dec_coffee_machine',
      'fur_office_chair',
      'dec_mug_deadline',
    ],
    completionRewards: [{ type: 'stars', amount: BALANCE.starsPer.setComplete }],
    iconFrame: 'ui_icon_set_office',
  },
  {
    id: 'set_garden',
    nameKey: 'set.set_garden.name',
    itemIds: ['dec_monstera', 'dec_hanging_pothos', 'dec_herb_pots', 'fur_plant_stand'],
    completionRewards: [{ type: 'stars', amount: BALANCE.starsPer.setComplete }],
    iconFrame: 'ui_icon_set_garden',
  },
] as const satisfies readonly SetDefInput[];
